import React from "react";
import AppTheme from "./components/AppTheme";
import TermsContent from "./components/TermsContent";
import { Divider } from "@mui/material";
import Footer from "./components/Footer";
import AppAppBar from "./components/AppAppBar";

const Terms: React.FC = (props: { disableCustomTheme?: boolean }) => {
	return (
		<AppTheme {...props}>
			<AppAppBar notHomePage />
			<TermsContent />
			<Divider />
			<Footer />
		</AppTheme>
	);
};

export default Terms;
